<script setup lang="ts">
import { computed } from 'vue'
import { publicPhotos, type PublicPhotoId } from '../content/public-photos'
import PhotoCredit from './PhotoCredit.vue'
const props = defineProps<{ image: PublicPhotoId; priority?: boolean }>()
const photo = computed(() => publicPhotos[props.image])
</script>
<template>
  <figure class="public-photo">
    <picture><source :srcset="`${photo.path}.avif`" type="image/avif"><img :src="`${photo.path}.webp`" :width="photo.width" :height="photo.height" :alt="photo.alt" :loading="priority ? 'eager' : 'lazy'" :fetchpriority="priority ? 'high' : 'auto'" decoding="async"></picture>
    <figcaption><span>{{ photo.caption }}</span><PhotoCredit :image="image" /></figcaption>
  </figure>
</template>
